/**
 * Remove any non numeric related characters from the scaleError.
 *  - removes leading > or <
 *  - keeps leading - (a negative number)
 *  - keeps . (decimals)
 *  - accepts `number` or `string` types as input as a few of our existing type definitions are incorrect
 *
 * Workaround for #419
 * - api scaleError can have a `>` sign (or other symbol), but we need it to be a number so should remove any non numeric characters
 */
export function convertErrorMarginToNumber(scaleError: string | number): number {
  return +(`${scaleError}`.replace(/[^\d.-]/g, '') || 0);
}
